import React, { useState, useMemo } from 'react';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'dva';
import { useIntl } from 'umi';
import TextField from '@material-ui/core/TextField';
import { useForm } from 'react-hook-form';
import { Box, Grid } from '@material-ui/core';
import { optionToKey, fmtThousand } from '@/utils/comUtil.js';
import { channelMap } from '@/constants.js';
import MemberDetailStyled from './MemberDetailStyled';

const MemberDetail = (props) => {
  //国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { handleSubmit } = useForm({});
  const dispatch = useDispatch();
  //关于邮箱和电话号码的校验
  const [validate, setValidate] = useState({ email: false, idCard: false });

  //出生日期受控
  const [
    birthday,
    // setBirthday
  ] = useState(null);
  //获取会员详情
  const datas = useSelector((state) => state.ml.getMemberDetail);

  const { params = {} } = props || {};
  const { id } = params || {};

  //编辑状态
  const [
    // editStatus,
    setEditStatus,
  ] = useState(false);
  const [, setEditLoading] = useState(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let newData = { ...datas };
  console.log('newData', newData);

  newData.channel = optionToKey(
    { ...channelMap, STOREWIFI: '门店WIFI' },
    newData.channel && newData.channel,
  );
  const { identities = [] } = newData || {};
  const {
    // createDate,
    identitySource,
    identityName,
    identityType,
    identityValue,
  } = (identities && identities[0]) || {};

  const Pca = useMemo(() => {
    let pca = [];
    if (datas) {
      if (datas['provinceName']) {
        pca.push(datas['provinceName']);
      }
      if (datas['cityName']) {
        pca.push(datas['cityName']);
      }
      if (datas['countyName']) {
        pca.push(datas['countyName']);
      }
    }
    return pca;
  }, [datas]);
  const selectList = [
    {
      label: formatMessage({ id: 'cm.member.detail.n03.lbl01' }),
      id: 'birthday',
      disabled: true,
    },
    {
      label: formatMessage({ id: 'cm.member.detail.n03.lbl02' }),
      id: 'signUpDate',
      disabled: true,
    },
    // {
    //   label: formatMessage({ id: 'cm.member.detail.n03.lbl03' }),
    //   id: 'channel',
    //   disabled: true,
    // },
    {
      label: formatMessage({ id: 'cm.member.detail.n03.lbl04' }),
      id: 'totalPoint',
      disabled: true,
    },
    {
      label: formatMessage({ id: 'cm.member.detail.n03.lbl05' }),
      id: 'availablePoint',
      disabled: true,
    },

    {
      label: formatMessage({ id: 'cm.member.detail.n03.lbl06' }),
      id: 'freezePoint',
      disabled: true,
    },
    {
      label: formatMessage({ id: 'cm.member.detail.n03.lbl07' }),
      id: 'upgradeBalance',
      disabled: true,
    },
    {
      label: '型动值',
      id: 'availableUgcPoint',
      disabled: true,
    },
    // {
    //   label: formatMessage({ id: 'cm.member.detail.n03.lbl08' }),
    //   id: 'subCompanyName',
    //   disabled: true,
    // },
    // {
    //   label: formatMessage({ id: 'cm.member.detail.n03.lbl09' }),
    //   id: 'registerStoreName',
    //   disabled: true,
    // },
    // {
    //   label: formatMessage({ id: 'cm.member.detail.n03.lbl10' }),
    //   id: 'mangeStoreName',
    //   disabled: true,
    // },

    // {
    //   label: formatMessage({ id: 'cm.member.detail.n03.lbl11' }),
    //   id: 'bindStoreName',
    //   disabled: true,
    // },
    {
      label: formatMessage({ id: 'cm.member.detail.n03.lbl12' }),
      id: 'email',
      disabled: true,
    },
    {
      label: formatMessage({ id: 'cm.member.detail.n03.lbl13' }),
      id: 'industry',
      disabled: true,
    },
    {
      label: formatMessage({ id: 'cm.member.detail.n03.lbl14' }),
      id: 'professional',
      disabled: true,
    },

    {
      label: formatMessage({ id: 'cm.member.detail.n03.lbl15' }),
      id: 'pca',
      extra: Pca,
      disabled: true,
    },
    {
      label: formatMessage({ id: 'cm.member.detail.n03.lbl16' }),
      id: 'address',
      disabled: true,
    },
    // {
    //   label: formatMessage({ id: 'cm.member.detail.n03.lbl17' }),
    //   id: 'shoeSize',
    //   disabled: true,
    // },
    {
      label: formatMessage({ id: 'cm.member.detail.n03.lbl18' }),
      id: 'maritalStatus',
      disabled: true,
    },
    {
      label: '证件类型',
      id: 'documentType',
      disabled: true,
    },
    {
      label: '证件号码',
      id: 'documentid',
      disabled: true,
    },
    // {
    //   label: formatMessage({ id: 'cm.member.detail.n03.lbl19' }),
    //   id: 'lastPurchaserStore',
    //   disabled: true,
    // },
    // {
    //   label: formatMessage({ id: 'cm.member.detail.n03.lbl20' }),
    //   id: 'lastPurchaserProducts',
    //   disabled: true,
    // },
    // {
    //   label: formatMessage({ id: 'cm.member.detail.n03.lbl21' }),
    //   id: 'isCrossGender',
    //   format: (text) => {
    //     return text ? '是' : '否';
    //   },
    //   disabled: true,
    // },
    // {
    //   label: formatMessage({ id: 'cm.member.detail.n03.lbl22' }),
    //   id: 'isOversize',
    //   disabled: true,
    //   format: (text) => {
    //     return text ? '是' : '否';
    //   },
    // },
    // {
    //   label: formatMessage({ id: 'cm.member.detail.n03.lbl23' }),
    //   id: 'tradeSizes',
    //   disabled: true,
    // },
    // {
    //   label: formatMessage({ id: 'cm.member.detail.n03.lbl24' }),
    //   id: 'lastPurchaserDate',
    //   format: (text) => {
    //     const now = dayjs();
    //     if (!text) {
    //       return '未购买';
    //     }
    //     const df1 = now.diff(text, 'day');
    //     return `${df1}天`;
    //   },
    //   disabled: true,
    // },
  ];
  const onFinish = (values) => {
    if (values.email) {
      setValidate({ ...validate, email: true });
    } else if (values.idCard) {
      setValidate({ ...validate, idCard: true });
    }
    setEditLoading(true);
    values['birthday'] = birthday && dayjs(birthday).format('YYYY-MM-DD');
    delete values['channel'];
    console.log('values', values);

    dispatch({
      type: 'ml/editMember',
      payload: {
        values: {
          memberID: id,
          memberIdentityRequestList: [
            {
              id: id,
              identitySource,
              identityName,
              identityType,
              identityValue,
            },
          ],
          membershipRequest: {
            ...values,
          },
        },
      },
      callback: (res) => {
        // newData=res.data;
        setEditLoading(false);
        if (res?.code !== '0') {
          // message.success('编辑成功');
          dispatch({
            type: 'ml/getMemberDetail',
            payload: {
              values: {
                memberID: id, //目前写死的为1，后续需要变动
              },
            },
          });
          return;
        }
        // message.error(res.message);
      },
    });
    //成功之后的回调执行
    setEditStatus(true);
  };

  const documentTypeList = [
    { id: '1', name: '身份证' },
    { id: '2', name: '其他' },
  ];
  return (
    <MemberDetailStyled>
      <form onSubmit={handleSubmit(onFinish)}>
        <div className={'load'}>
          <Grid container spacing={7} sx={{ gap: '24px 0', marginTop: 0 }}>
            {selectList.map((item, index) => {
              let value;
              if (item.extra) {
                value = item.extra;
              } else if (item.format) {
                value = item.format(newData[item.id]);
              } else if (newData[item.id] === 0) {
                value = '0';
              } else if (
                [
                  'totalPoint',
                  'availablePoint',
                  'freezePoint',
                  'upgradeBalance',
                  'availableUgcPoint',
                ].includes(item.id)
              ) {
                value = fmtThousand(newData[item.id] || 0, 0);
              } else if (item.id === 'documentType') {
                value =
                  documentTypeList.find((i) => i.id === newData[item.id])
                    ?.name || '--';
              } else {
                value = newData[item.id] || '--';
              }
              return (
                <Grid
                  item
                  xs={4}
                  key={`vip${index}`}
                  sx={{ paddingTop: '0!important' }}
                >
                  <Box display="flex" flexDirection="column">
                    <TextField
                      id="filled-read-only-input"
                      className="text-detail-info"
                      disabled={item.disabled}
                      label={
                        <Box className="text-detail-label">{item.label}</Box>
                      }
                      value={value}
                      InputProps={{
                        readOnly: true,
                      }}
                      variant="standard"
                      name={item.id}
                    />
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </div>
        {/* </Loading> */}
      </form>
    </MemberDetailStyled>
  );
};

export default MemberDetail;
